import { render, staticRenderFns } from "./MyUserProfile.vue?vue&type=template&id=17da196d&"
import script from "./MyUserProfile.vue?vue&type=script&lang=js&"
export * from "./MyUserProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports